<template>
	<div class="profile">
		<section class="py-5 bg-grey200">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8">
						<div class="card custom-card">
							<div class="card-body">
								<h2 class="text-center mt-2">Picture Gallery</h2>
								<div  class="row my-4 col-md-12 justify-content-center">
									<div v-for="(n, index) in 40" :key="index" @click="selectPicture(n)" class="smileyCard col-md-2 text-center ">
										<img
										v-if="selected(n) || n == previousImage "
							class="check-icon "
							src="../../assets/img/check_circle.svg"
							alt=""
						/>
										<img v-bind:src= "require(`@/assets/img/${n}.png`)" alt class="icon" width="80" height="100" />
									</div>
								</div>
								<div class="row  justify-content-center">
									<div class="col-md-12 text-center">
										<button type="submit" @click="savePicture" class="btn btn-primary">
											OK
										</button>
										<button type="button" @click="cancelChange" class="btn btn-primary ml-5">
											CANCEL 
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import HomeNav from "@/components/HomeNav.vue";

export default {
	name: "Profile3",
	components: {
		HomeNav,
	},
	props: ["previousImage"],
	data() {
		return {
			data: null,
			selectedPicture: '',
			savedPicture:'',
		};
	},
	mounted() {
		window.scroll(0, 0);
	},
	created() {
		this.$store.commit("showPopup", false);
	},
	methods: {
		selectPicture(n){
			this.selectedPicture = n;
			this.previousImage = n
		},
		selected(n){
			if (n == this.selectedPicture){
				return true
			} else
			return false
		},
		savePicture(){
			this.savedPicture = this.selectedPicture;
			this.$emit("clicked", this.savedPicture )
		},
		cancelChange(){
           this.$emit("clickedcancel" )
		}
	},
	computed: {
		
	},
};
</script>

<style>
.smileyCard{
	background: #b5bbbe 0% 0% no-repeat padding-box;
	border-radius: 20px;
	opacity: 1;
	margin-left: 20px  !important;
	margin-bottom: 20px  !important;
	cursor: pointer;
}

.smileyCard:focus,.smileyCard:hover{
	cursor: pointer;
	border-color:  #679F3D !important;
	-webkit-box-shadow: 0 0 0 0.2rem rgba(128, 180, 64, 0.5);
    box-shadow: 0 0 0 0.2rem rgba(109, 150, 59, 0.9);
}

.check-icon {
	position: absolute;
	right: 20px;
	left: 20px;
	margin-right: 0px;
	padding-right: 0px;
	margin-bottom: 0px  !important;
	padding-bottom: 0px  !important;
	transform: translate(190%, -40%);
	height: 30px;
	width: 30px;
	display: flex !important;
	justify-content: center !important;

}
</style>
